import angular from 'angular';
import template from './patient-modal-enable-video.html';
import PatientPhotoCaptureNotification from '../patient-photo-capture-notification/patient-photo-capture-notification';
const patientModalEnableVideo = {
    template,
    bindings: {
        onBack: '&',
        patient: '<',
        room: '<',
        onContinueWithoutCamera: '&',
        onCheckIn: '&',
        onEnableCamera: '&',
        checkInPromise: '<',
        onEnableWebcamAndCheckIn: '&',
        isEnableCameraButtonClicked: '<',
        currentInstitution: '<',
    },
};
export default angular
    .module('doxy.patient.modal.patientModalEnableVideo', [
    PatientPhotoCaptureNotification,
])
    .component('patientModalEnableVideo', patientModalEnableVideo).name;
